module.exports = __webpack_public_path__ + "static/media/tanzania-flag-round-small.fbf521ea.jpg";